const strings = {
  app: {
    name: "Szervizkód"
  }
};
export default strings;



// WEBPACK FOOTER //
// ./src/themes/prior/strings.js